<prada-calendar [events]="calendarEvents"
  (eventClick)="onEventClick($event)"
  (dateChange)="dateChange($event)"></prada-calendar>